<template>
	<div class="newpage">
		

		<div class="printTest-box">
			
			<div class="fenpi">
					<span class="fenpi-item">{{$t('other.a485')}} {{th_printdata.length}}； {{$t('other.a486')}}</span>
					<span class="fenpi-item" v-show="checked">{{$t('other.a487')}}1-{{pageSize}}{{$t('other.a488')}}；</span>
					<span class="fenpi-item" v-show="checked">{{$t('other.a489')}}：</span>
					<div class="block fenpi-item"  v-show="checked">
					    <el-pagination
						style="margin-top: 21px;"
						size="mini"
					      @size-change="handleSizeChange"
					      @current-change="handleCurrentChange"
					      :current-page.sync="currentPage2"
					      :page-sizes="[10, 20, 30, 40]"
					      :page-size="10"
					      layout="sizes, prev, pager, next"
					      :total="th_printdata.length">
					    </el-pagination>
					  </div>
				
					<el-checkbox class="fenpi-item" v-model="checked" @change="getPirntPdf"><span style="color: red;">{{checked ? $t('other.a490') : $t('other.a491') }} </span></el-checkbox>
					<span style="margin-left: 15px;">{{$t('other.a492')}}：{{loadedList.length}}/{{th_printdata.length}}</span>
					  
			</div>
			<div id="printTest">
				<div style="display: flex;flex-direction: column;align-items: center;">
				    <div >
						<div ref="menuItem" v-if="th_printdata.length">
							<div class="first-item"   :style="sliderStyle"     v-for="(item,index) in listCopy" :key="index">
								<div v-if="item.genre === 'order' "  style="background-color: #fff;">
									<div style="width: 100%;display: flex;justify-content: space-between;">
										 <span class="desc">{{item.printNum+1}}st print</span>
										
										 <span class="desc">NO.{{item.NO+1}}</span>
									</div>
									<div class="loading-box" v-if="!item.image">
										<i class="el-icon-loading"></i>
										<span style="font-size: 18px;">loading...</span>
									</div>
									<div   style="width: 100%;overflow: hidden;">
										<div  >
											<img  style="width: 100%;"  :src='item.image' />
										</div>
									</div>
									<div style="page-break-after:always"></div>
								</div>	
				
								
							</div>
							
						</div>
					</div>
				</div>
				
				
				  
			</div>
			
			 
			
			
			
		</div>
		<div style="flex: 1;">
			    <div style="height: 200px;">
					<el-button style="margin: 20px 0 0 30px;" type="primary" v-print="'#printTest'"  @click="addPrintTime()">{{$t('other.a342')}}</el-button>
				</div>
				<div style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a346')}}</div>
					 <el-select style="margin-left: 15px;" size="mini" v-model="value" :placeholder="$t('other.a50')" @change="chosePage()">
						<el-option
						  v-for="item in options"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					 </el-select>
				</div>
				<div v-show="value == '10' "  style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a347')}}</div>
					<el-input style="width:120px;padding-left:15px" @keyup.native="oop" size="mini" v-model="widthValue" :placeholder="$t('other.a319')"></el-input>
					<label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
				</div>
				<div v-show="value == '10' "  style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a348')}}</div>
					<el-input style="width:120px;padding-left:15px" @keyup.native="oop1" size="mini" v-model="heightValue" :placeholder="$t('other.a319')"></el-input>
					<label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
				</div>
			
		</div>
		
	</div>
	
</template>
<script>
import utils from '../utils/utils'
import api from '../api/moudles/print.js'
	import {
		mapState,
		mapMutations ,
	     mapActions,
	} from 'vuex'
	import loading from './loading.vue'
	import Papa from 'papaparse'
	import json2csv from 'json2csv'
	import csvExportor from "csv-export";
	import pdf from 'vue-pdf'
	export default {
	    data() {
	      return {
	        th_printdata:[],
			arr:[],
			options: [{
			          value: 1,
			          label: this.$t('other.a493')
			        }, {
			          value: 2,
			          label: this.$t('other.a494')
			        }, {
			          value: 3,
			          label: this.$t("other.a350")
			        }, {
			          value: 4,
			          label: this.$t("other.a351")
			        }],
					value:3,
					sliderStyle:{
						'width':'98mm',
						'height':'130mm',
						'background-color': '#fff',
						'margin-top':'10px',
						'position':'relative'
					},
					widthValue:'100mm',
					heightValue:'150mm',
					checked:false,
					options: [{
					          value: '10',
					          label: this.$t("other.a350")
					        }, {
					         value: '20',
					         label: 'A4'
					        }, {
					          value: '30',
					          label: 'A5'
					        }, ],
					        value: '10',
							loadingList:[],
							loadedList:[],
							currentPage2: 1,
							pageSize:10,
							chooseList:null,
							generateOrderId:[]
					
		  }
	    },
		components:{
			loading,
			pdf
		},
		computed:{
			...mapState({
				picklist: state => state.order.picklist,
				seller: state => state.login.userInfo.userId,
				buttonMapList: state => state.print.buttonMapList,
			}),
			
			listCopy(){
				if(this.checked){
					let list=this.th_printdata
					let list2=list.slice((this.currentPage2 - 1) * this.pageSize, (this.currentPage2) * this.pageSize)
					console.log(list2)
					console.log(list)
					this.chooseList=list2
					return list2
				}else{
					return this.th_printdata
				}
			},
		
			
		},
		watch:{
			listCopy(){
				console.log(this.listCopy)
			}
		},
		created(){
	        // this.src=pdf.createLoadingTask(this.src)
			this.init()
		},
	
		methods:{
			...mapActions('order', [
				'getUnprocessOrder',//获取所有商店待处理订单
				'auditOrder',
				'getPrintOrder', //打印订单
				'getOrdersBytrickNo'
				
			]),
			...mapActions('print', [
				'addPrintNum',
			
			]),
			...mapMutations('print', [
				'SET_ITEMS',
				'SET_HAS_PRINTED',
				'SET_TTP',
				'SET_HAS_PRINTED_READY',
				'INIT_DATA',
				'FAST_PRINT',
				'UPDATA_PAGE',
				'SENT_PPT'
			]),
			addPrintTime(){
				let arr = []
				this.listCopy.forEach(p => {
					if(p.trackingNo !== "" && p.image!== null) {
						arr.push(p.orderId) 
					}
				})
				this.addPrintNum(arr)
			},
			
			 start_print(){
			        this.$print(this.$refs.dfbfjj);//$refs的值要和html里的ref一致
			    },
			
			
			handleSizeChange(val) {
			        console.log(`每页 ${val} 条`);
					this.pageSize=parseInt(`${val}`)
			      },
			handleCurrentChange(val) {
				
				this.currentPage2=parseInt(`${val}`)
				console.log(this.chooseList);
				this.getPirntPdf()
				
				
			},
			//开启分批打印时，触发面单再次请求
			getPirntPdf(){
				setTimeout(() => {
					console.log(this.chooseList)
					let arr=this.chooseList.map(p => {
						return p.logisticInfo && p.trackingNo === ''?  JSON.parse(p.logisticInfo.info_needed.methods) : null
					})
					arr=utils.unique(arr)
					arr[0] === null ? arr.splice(0,1) : arr[0]
					
					this.generateOrderId=arr.map(p => {
						if(p !== null) {
							return p.orderId
						}
					})
					
					console.log(arr)
					console.log(this.generateOrderId)
					if(this.generateOrderId.length){
						console.log(8888)
						api
						.startReadyOrders(arr)
						.then(res => {
							if(res.code === 200) {
								console.log('发送订单请求',res.data)
								this.getNewOrderList(this.generateOrderId)
							}
						})
					}
				
				},1000)
			},
			
			//获取最新的面单
			getNewOrderList(arr){
				api
				.getNewOrders(arr)
				.then(res => {
					if(res.code === 200){
						console.log('获取到最新的订单',res.data)
						let newData=res.data
						newData.forEach(p => {
							this.th_printdata.forEach(i => {
								if(i.orderId == p.orderId && p.image !== null && p.ready == true){
									i.image=p.image
								}
							})
							this.generateOrderId.forEach((k,index) => {
								if(k === p.orderId && p.ready == true && p.image!== null){
									this.generateOrderId.splice(index,1)
								}
							})
						})
						
						if(this.generateOrderId.length> 0){
							this.getNewOrderList(this.generateOrderId)
						}
					}
				})
			},
			
			chosePage(){
				console.log(this.value)
				if(this.value == '20'){
					this.sliderStyle.width='210mm'
					this.sliderStyle.height='297mm'
				}else if(this.value == '30'){
					this.sliderStyle.width='148mm'
					this.sliderStyle.height='210mm'
				}else if(this.value == '10'){
					this.sliderStyle.width='100mm'
					this.sliderStyle.height='150mm'
					this.widthValue='100'
					this.heightValue='150'
				}
			},
			
			oop1(){
				
				this.sliderStyle.height=this.heightValue + 'mm'
			},
			oop(){
				console.log(this.widthValue)
				this.sliderStyle.width=this.widthValue + 'mm'
			},
			//深拷贝数组
			copy (obj) {
			        var newobj = []
			        if(typeof obj !== 'object'){
			            return;
			        }
			        for(var i in obj){
			           newobj[i] = typeof obj[i] === 'object' ? this.copy(obj[i]) : obj[i];
			        }
			        return newobj
			},
			//从storage上拿下将要打印的item
			init(){
				let list1=JSON.parse(localStorage.getItem('printcontentOver5'))
				let list2=JSON.parse(localStorage.getItem('printcontent'))
				
				this.th_printdata=[...list1,...list2]
				this.arr=this.copy(this.th_printdata)
				
				
				
				
				this.th_printdata.forEach(p =>{
					p.genre='order'
					if(p.sent && p.image !== null ){
						this.loadedList.push(p)
					}else{
						this.loadingList.push(p)
					}
				})
				
				
				this.arr.forEach(p => {
					p.genre='picklist'
				})
				console.log(this.th_printdata)
				console.log(this.arr)
				console.log(list2)
				this.th_printdata=[...this.th_printdata]
				this.th_printdata.sort((a,b) => {return a.NO-b.NO })
				
				console.log(this.th_printdata)
				
				
				
				
			},
			
		
			
		     ttp(){
				var headstr = "<html><head><title></title></head><body>";
				var footstr = "</body>";
				var newstr = this.$refs.menuItem.innerHTML;
				const oldstr = document.body.innerHTML;
				document.body.innerHTML = headstr+newstr+footstr;
				setTimeout(() => {
					document.body.innerHTML = oldstr;
				},1000)
				window.print(); 
				return false
			
			
			},
		
			
			
			getTiem(time) {
				console.log(time)
				if(typeof(time) ==Array ){
					return 'pending update'
				}else{
					
					return utils.renderTime(time)
				}
				
				
			},
		}
	  }
</script>

<style>
	
	.newpage{
		width: 100%;
		background: #fff;
		z-index: 99999;
		display: flex;
		position: absolute;
		/* display: flex;
		flex-direction: column;
		justify-content: center; */
	
	}
	
	
	@page
	{ 
		margin: 0mm 0mm 0mm 0mm;  
	}
	@page:first
	{ 
		margin-top: -5mm ;  
	}
	
	
	.pic-box{
	  width: 100%;
	  image-rendering:-moz-crisp-edges;
	  image-rendering:-o-crisp-edges;
	  image-rendering:-webkit-optimize-contrast;
	  image-rendering: crisp-edges;
	  -ms-interpolation-mode:nearest-neighbor;
	 }
	
	.newpage .pick-list-wrpper{
		width: 100%;
		
		font-size: 12px;
		position: relative;
	}
	
	.orderpage-btn{
		width: 800px;
		margin: 0 auto;
		display: flex;
		justify-content: flex-end;
		padding: 10px 0;
	}
	
	.newpage .print-area{
		
		
		margin-bottom: 200px;
		
		
	}
	.desc-info{
		width: 798px;
		
		border: 2px #000000 solid;
	}
	
	.newpage .orderpage-poo-box{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 5px;
		border-bottom: 2px #000000 dashed
	}
	
	.newpage  .orderpage-poo{
		min-width: 265px;
		height: 40px;
		border: 2px solid #000000;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		margin: 5px 10px;
	}
	
	.newpage  .receipt-item{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding:5px 10px;
	}
	
	.newpage  .receipt-item .area {
		display: inline-block;
		width: 50%;
		font-size: 18px;
	}
	
	.newpage  .desc-info-left-text{
		font-size: 18px;
		font-weight: bold;
		padding-right: 30px;
	}
	
	.newpage  .desc-info-footer{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 5px 10px;
	}
	
	.newpage  .tto{
		display: inline-block;
		width: 200px;
		text-align: center;
		box-sizing: border-box;
		padding: 5px;
	}
	.newpage  .tto01{
		display: inline-block;
		width: 100px;
	}
	.newpage  .cco{
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		border-bottom: 1px #000000 solid;
		box-sizing: border-box;
		padding: 0 10px;
	}
	
	.newpage  .city-tap{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 0;
		padding: 5px 15px;
		font-size: 18px;
	}
	
	.newpage  .city-tap01{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 5px;
		font-size: 18px;
		padding: 5px 15px;
	}
	
	
	
	
	.newpage  .desc{
		/* position: absolute;
		top: 40%;
		left: 25%;
		bottom: 0;
		right: 0;
		margin: auto; */
		font-size: 18px;
		font-weight: bold;
		color: red;
		opacity: 0.3;
		
		
		
	}
	.newpage  .oook{
		margin-bottom: 20px;
		
	}
	
	.loading-box{
		width: 100px;
		height: 100px;
		position: absolute;
		bottom: 0;
		top: 0;
		left: 0;
		right: 0;
		margin: auto;
		text-align:center;
	}
	
/* 	.pp-wrapper{
		position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto;
	}	 */
	
	.newpage  .printTest-box{
		width: 80%;
		overflow-y: auto;
		height: 100vh;
		background-color: #000;
		position: relative;
	
	}
	
	.newpage  .page-box{
		/* width: 800px;
		height: 670px; */
		overflow: hidden;
		background-color: #fff;
		/* position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto; */
		
	}
	
	.newpage .el-icon-loading:before {
	    content: "\E6CF";
	    font-size: 60px;
	}
	
	.el-popper{
		z-index: 999999!important;
	}
	
	.img-wrapper{
	  width: 1100px;
	  height: 1188px;
	  margin: -369.5px -354.5px;
	  transform: scale(0.36);
	}
	
	.fenpi{
		display: flex;
		align-items: center;
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #fff;
		position: fixed;
		bottom: 0;
		z-index: 999999;
		font-size: 14px;
		padding-left: 15px;
	}
	
	.fenpi-item{
		margin-right: 10px;
	}

	.first-item:nth-child(1){
		margin-top:30px!important;
	}
	
	
	
</style>
